/** Shared, squared auth form primitives (storefront + workspace). */

export type AuthFormTone = 'light' | 'dark';

export function authLabelClass(tone: AuthFormTone = 'light'): string {
  return tone === 'dark'
    ? 'block text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-400'
    : 'block text-[11px] font-semibold uppercase tracking-[0.08em] text-slate-600';
}

export function authHintClass(tone: AuthFormTone = 'light'): string {
  return tone === 'dark' ? 'text-xs text-slate-500' : 'text-xs text-slate-500';
}

export function authInputClass(tone: AuthFormTone = 'light'): string {
  const base =
    'w-full rounded-sm border bg-white px-3 py-2.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:ring-1 disabled:cursor-not-allowed disabled:bg-slate-50';
  if (tone === 'dark') {
    return `${base} border-slate-600 bg-slate-950 text-white placeholder:text-slate-500 focus:border-emerald-500 focus:ring-emerald-500`;
  }
  return `${base} border-slate-300 focus:border-slate-900 focus:ring-slate-900`;
}

export function authPrimaryButtonClass(tone: AuthFormTone = 'light'): string {
  const base =
    'inline-flex w-full items-center justify-center rounded-sm px-4 py-2.5 text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-60';
  if (tone === 'dark') {
    return `${base} bg-emerald-600 text-white hover:bg-emerald-500 focus-visible:ring-emerald-400/80`;
  }
  return `${base} bg-slate-900 text-white hover:bg-slate-800 focus-visible:ring-slate-400/80`;
}

export function authSecondaryButtonClass(tone: AuthFormTone = 'light'): string {
  const base =
    'inline-flex w-full items-center justify-center rounded-sm border px-4 py-2.5 text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-60';
  if (tone === 'dark') {
    return `${base} border-slate-600 bg-transparent text-slate-200 hover:bg-slate-800 focus-visible:ring-slate-500/80`;
  }
  return `${base} border-slate-300 bg-white text-slate-800 hover:bg-slate-50 focus-visible:ring-slate-300/80`;
}

export function authLinkClass(tone: AuthFormTone = 'light'): string {
  return tone === 'dark'
    ? 'text-xs font-medium text-slate-400 underline-offset-2 hover:text-white hover:underline'
    : 'text-xs font-medium text-slate-600 underline-offset-2 hover:text-slate-900 hover:underline';
}

export function authCardClass(): string {
  return 'rounded-sm border border-slate-200 bg-white shadow-sm';
}

export function authErrorClass(tone: AuthFormTone = 'light'): string {
  return tone === 'dark'
    ? 'rounded-sm border border-red-900/50 bg-red-950/40 px-3 py-2 text-xs text-red-200'
    : 'rounded-sm border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-800';
}
